export const VIDMAX_DEFAULT_DEV_TOKEN = "lomin-integration"

const VIDMAX_DEV_TOKEN_PATTERN = /^lomin-[a-z0-9](?:[a-z0-9._-]{0,62}[a-z0-9])?$/i

export const isVidmaxDevToken = (token: string): boolean => VIDMAX_DEV_TOKEN_PATTERN.test(token)

export const isVidmaxLocalDevHost = (hostname: string): boolean => {
  if (hostname === "localhost" || hostname === "::1" || hostname === "0.0.0.0") return true

  const octets = hostname.split(".").map(Number)
  if (octets.length !== 4 || octets.some((octet) => !Number.isInteger(octet) || octet < 0 || octet > 255)) {
    return false
  }

  return (
    octets[0] === 10 ||
    octets[0] === 127 ||
    (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) ||
    (octets[0] === 192 && octets[1] === 168)
  )
}

export const getVidmaxDefaultDevToken = (hostname: string): string =>
  isVidmaxLocalDevHost(hostname) ? VIDMAX_DEFAULT_DEV_TOKEN : ""
